export interface SiteAuditIssueData {
  area: 'SEO' | 'Performance';
  category: string;
  name: string;
  description?: string;
  impact?: string;
}

export interface SiteAuditIssuesPayload {
  issues: SiteAuditIssueData[];
}

function isSiteAuditIssueData(value: unknown): value is SiteAuditIssueData {
  if (!value || typeof value !== 'object') {
    return false;
  }

  const issue = value as Record<string, unknown>;

  return (
    (issue.area === 'SEO' || issue.area === 'Performance')
    && typeof issue.category === 'string'
    && typeof issue.name === 'string'
    && (issue.description === undefined || typeof issue.description === 'string')
    && (issue.impact === undefined || typeof issue.impact === 'string')
  );
}

export function serializeSiteAuditIssuesPayload(payload: SiteAuditIssuesPayload): string {
  return JSON.stringify(payload);
}

export function parseSiteAuditIssuesPayload(content: string): SiteAuditIssuesPayload | null {
  try {
    const payload = JSON.parse(content) as { issues?: unknown };

    if (!Array.isArray(payload.issues)) {
      return null;
    }

    const issues = payload.issues.filter(isSiteAuditIssueData);

    if (issues.length === 0) {
      return null;
    }

    return { issues };
  } catch {
    return null;
  }
}
